import React from 'react';

const Address = () =>
  <address>
    <b>Lenses for Hire</b><br/>
    The ONE Building<br/>
    St Peters Road<br/>
    Maidenhead<br/>
    SL6 7QU
  </address>

export default Address;
